import { render, staticRenderFns } from "./Discussion.vue?vue&type=template&id=297b74e4&scoped=true"
import script from "./Discussion.vue?vue&type=script&lang=js"
export * from "./Discussion.vue?vue&type=script&lang=js"
import style0 from "./Discussion.vue?vue&type=style&index=0&id=297b74e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297b74e4",
  null
  
)

export default component.exports